import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RefreshComponent } from './refresh/refresh.component';
import { ResetPasswordNewComponent } from './reset-password-new/reset-password-new.component';
import { NavbarComponent } from './navbar/navbar.component';
import { PhoneInputComponent } from './shared/phone-input/phone-input.component';
import { CommonImportsModule } from './shared/common-imports/common-imports.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatNativeDatetimeModule } from '@mat-datetimepicker/core';
import { AppInterceptorService } from './app-interceptor.service';
import { TraceService, createErrorHandler } from '@sentry/angular-ivy';
import { RecoverComponent } from './recover/recover.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AttendanceComponent } from './task-management/attendance/attendance.component';
import { RegularizationListComponent } from './task-management/regularization/regularization-list/regularization-list.component';
import { TasksComponent } from './task-management/tasks/tasks.component';
import { LeaveListComponent } from './task-management/leave/leave-list/leave-list.component';
import { RosterListComponent } from './task-management/roster/roster-list/roster-list.component';

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		RefreshComponent,
		ResetPasswordNewComponent,
		NavbarComponent,
		PhoneInputComponent,
		RecoverComponent,
		ResetPasswordComponent,
		AttendanceComponent,
		RegularizationListComponent,
		TasksComponent,
		LeaveListComponent,
		RosterListComponent
	],
	imports: [
		AppRoutingModule,
		CommonImportsModule,
		BrowserAnimationsModule,
		BrowserModule
	],
	providers: [
		{
			provide: ErrorHandler,
			useValue: createErrorHandler({
				showDialog: false,
			}),
		},
		{
			provide: TraceService,
			deps: [Router],
		},
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => { },
			deps: [TraceService],
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AppInterceptorService,
			multi: true
		},
		MatNativeDatetimeModule,
		DatePipe
	],
	bootstrap: [AppComponent]
})
export class AppModule {

}
